module.exports = "img {\n  postion: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n}\n\na{\n  display: inline-block;\n  width: 100%;\n  text-align: center;\n  margin-top:15px;\n  font-size: 45px;\n  color: rgba(255, 124, 4, 1.0);\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/page-not-found/page-not-found.component.css
// module id = ./src/app/page-not-found/page-not-found.component.css
// module chunks = main